import ApiService from '@/services/Base/ApiService';

/* eslint-disable */
const getDefaultState = () => {
  return {
    periods: [],
    selectedPeriod: null,
  }
}

const state = getDefaultState()

const getters = {
  getPeriods(state) {
    return state.periods;
  },
}

const mutations = {
  setPeriods(state, data) {
    state.selectedPeriod = data.result[0];
    state.periods = data.result;
  },

  setSelectedPeriod(state, period) {
    state.selectedPeriod = period;
  },
}

const actions = {
  async fetchPeriods(context) {
    try {
      if (context.state.periods.length > 0) {
        return;
      }
      const response = await ApiService.get('SupervisedPeriod');
      if (response.statusCode === 200) {
        context.commit('setPeriods', response)
      } else {
        console.error('Error fetching data:', response.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
